import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CodeConverter } from 'server/entity/code-converter';
import { environment } from 'src/environments/environment';
import { AppCsmSetting, AppCsmSettingDetail } from '../interface/app-csm-setting';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {

  constructor(private http: HttpClient) { }

  getCodeConverter(lang: string, mainCategory: string, subCategory?: string): Observable<any> {
    // const url = `/api/codeconverter/${lang}/${mainCategory}/${isNullOrEmpty(subCategory) ? '' : subCategory}`;
    const url = `${environment.logisticsApiUrl}/Common/getCodeConverterList/${lang}/${mainCategory}/${isNullOrEmpty(subCategory) ? '' : subCategory}`;
    return this.http.get<CodeConverter[]>(url).pipe(map(options => {
      return options.filter(x => x.isActivated === 1);
    }));
  }

  getErrorCodes(lang: string, category?: string): Observable<any> {
    // const url = `/api/errorcode/${lang}/${isNullOrEmpty(category) ? '' : category}`;
    // TODO SAM 一定沒有{code}，後端要改
    const url = `${environment.logisticsApiUrl}/Common/getErrorCode/${lang}/${isNullOrEmpty(category) ? '' : category}`;
    return this.http.get(url);
  }

  // getRecommendationAddressThroughLogistics(inputObj: any): Observable<any> {
  //   const url = `${environment.logisticsApiUrl}/ai/getRecommendationAddress`;
  //   return this.http.post(url, inputObj);
  // }

  getSystemParam(paramkey: string, version?: number): Observable<any> {
    // const url = `/api/systemparam/${paramkey}/${isNullOrEmpty(version) ? '' : version}`;
    const url = `${environment.logisticsApiUrl}/Common/getSystemParamList/${paramkey}/${isNullOrEmpty(version) ? '' : version}`;
    return this.http.get(url);
  }

  getCountry(): Observable<any> {
    // const url = `/api/country`;
    const url = `${environment.logisticsApiUrl}/Common/getCountryList`;
    return this.http.get(url);
  }

  getCityByCountry(country: string): Observable<any> {
    // const url = `/api/city/${country}`;
    const url = `${environment.logisticsApiUrl}/Common/getCountryCityList/${country}`;
    return this.http.get(url);
  }

  getAssignmentDistrictBy(facility?: string, country?: string): Observable<any> {
    // const url = `/api/assignmentdistrict/${isNullOrEmpty(facility) ? 'X' : facility}/${isNullOrEmpty(country) ? '' : country}`;
    const url = `${environment.logisticsApiUrl}/Common/getAssignmentDistrictList/${isNullOrEmpty(facility) ? 'X' : facility}/${isNullOrEmpty(country) ? '' : country}`;
    return this.http.get(url);
  }

  getAppCsmSetting(cmsCode:string):Observable<AppCsmSetting>{
    const url = `${environment.logisticsApiUrl}/appCsmSetting/getAppCsmSettingByCsmCode/${cmsCode}`;
    return this.http.get<AppCsmSetting>(url);
  }

  searchCsmDetailSetting(csmCode: string): Observable<AppCsmSettingDetail[]>{
    const url = `${environment.logisticsApiUrl}/appCsmSetting/getAppCsmSettingDetailByCsmCode/${csmCode}`;
    return this.http.get<AppCsmSettingDetail[]>(url);
  }

}
